import React from 'react';
import { Link } from 'react-router-dom';
import FlikLogo from '../Logo/FlikLogo';
import './Footer.css';

/**
 * Global site footer, shared by every page (mounted once in App).
 *
 * Three blocks in the FLIK Alpine v3 language (dark ladera surface, mono
 * uppercase headings, amber accents, snow-cut social tiles):
 *   · brand + slogan + social links,
 *   · "Explora" — in-app resource sections,
 *   · contact.
 *
 * The resource links point at in-app routes that are not built yet, so for now
 * they resolve through the catch-all back to the home screen. The social URLs
 * are still to be defined (placeholder "#").
 */
const EXPLORE_LINKS = [
  { label: 'Guías de montaña', to: '/guias' },
  { label: 'Consejos de seguridad', to: '/seguridad' },
  { label: 'Cómo preparar una ruta', to: '/preparar-ruta' },
  { label: 'Equipamiento', to: '/equipamiento' },
  { label: 'Meteo y condiciones', to: '/meteo' },
  { label: 'FAQ', to: '/faq' },
];

/* Brand glyphs kept inline so they inherit currentColor (muted → amber on
   hover) and need no external asset requests. */
function FacebookIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M13.5 22v-8h2.7l.4-3.2h-3.1V8.75c0-.93.26-1.56 1.6-1.56h1.7V4.3A22.6 22.6 0 0 0 14.3 4.2c-2.46 0-4.14 1.5-4.14 4.26v2.34H7.4V14h2.76v8h3.34z" />
    </svg>
  );
}

function InstagramIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" aria-hidden="true">
      <rect x="3.2" y="3.2" width="17.6" height="17.6" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.4" cy="6.6" r="1.15" fill="currentColor" stroke="none" />
    </svg>
  );
}

function XIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M18.24 2.5h3.3l-7.2 8.23L22.8 21.5h-6.62l-5.19-6.78-5.93 6.78H1.75l7.7-8.8L1.2 2.5h6.79l4.69 6.2 5.56-6.2zm-1.16 17.02h1.83L7.01 4.38H5.05L17.08 19.52z" />
    </svg>
  );
}

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="Footer">
      <div className="Footer-inner">
        <div className="Footer-brand">
          <FlikLogo height={26} />
          <span className="Footer-eyebrow">Rutas · Cimas · Barrancos</span>
          <p className="Footer-slogan">
            La montaña,
            <br />
            a un flik.
          </p>
          <div className="Footer-socials">
            <a
              className="Footer-social flik-cut-sm"
              href="#"
              aria-label="FLIK en Facebook"
            >
              <FacebookIcon />
            </a>
            <a
              className="Footer-social flik-cut-sm"
              href="#"
              aria-label="FLIK en Instagram"
            >
              <InstagramIcon />
            </a>
            <a className="Footer-social flik-cut-sm" href="#" aria-label="FLIK en X">
              <XIcon />
            </a>
          </div>
        </div>

        <nav className="Footer-col" aria-label="Explora FLIK">
          <span className="Footer-heading">Explora</span>
          <ul className="Footer-links">
            {EXPLORE_LINKS.map((link) => (
              <li key={link.to}>
                <Link className="Footer-link" to={link.to}>
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="Footer-col">
          <span className="Footer-heading">Contacto</span>
          <a className="Footer-email" href="mailto:flik@flik.es">
            flik@flik.es
          </a>
          <span className="Footer-meta">Valencia · España</span>
          <span className="Footer-meta">Est. 2026</span>
        </div>
      </div>

      <div className="Footer-bottom">
        <div className="Footer-bottomInner">
          <span className="Footer-copy">© {year} FLIK · Nos vemos en la montaña</span>
          <div className="Footer-legal">
            <Link to="/terminos">Términos</Link>
            <span aria-hidden="true">·</span>
            <Link to="/privacidad">Privacidad</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
